import { PenLine } from "lucide-react";
import Button from "../foundational/Button";
import { haceCuanto, nombreDelBorrador } from "../pae-detallado/borradorPae";

// El PAE sin terminar de la interna, en una FILA bajo su turno (propuesta de
// la interfaz por experiencia, aprobada el 2026-10-16). Antes era el aviso
// azul arriba del inicio, que competía con el turno por ser lo primero. Aquí
// queda segundo: lo de hoy es el turno, y lo empezado se retoma sin
// esconderse. Una sola card protagonista por pantalla (contrato de Card), así
// que esto es una fila, no una card. Mismas palabras que el aviso y que
// MomentoEstudiante (mismo concepto, mismo texto). Navegación: cero háptica.
// Anti-culpa: un borrador viejo se describe ("Hace 3 h"), jamás se reprocha.
export default function FilaPaeSinTerminar({ borrador, onContinuar, onDescartar }) {
  if (!borrador || typeof borrador !== "object") return null;
  return (
    <section aria-label="Tu PAE sin terminar" className="mt-3 rounded-tk-md border border-edge bg-paper px-4 py-3">
      <div className="flex items-start gap-3">
        <span aria-hidden="true" className="w-9 h-9 rounded-full bg-surface grid place-items-center text-accent flex-shrink-0">
          <PenLine size={17} strokeWidth={1.7} />
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-micro uppercase tracking-wide font-semibold font-sans text-ink-muted">Tu PAE</p>
          <p className="text-body font-semibold text-ink font-sans leading-tight">{nombreDelBorrador(borrador)} sin terminar</p>
          <p className="mt-0.5 text-small text-ink-muted font-sans">{haceCuanto(borrador.timestamp)}. ¿Continuar donde lo dejaste?</p>
        </div>
      </div>
      <div className="mt-2.5 flex flex-wrap gap-2 pl-12">
        <Button variant="secondary" size="sm" className="min-h-[44px]" onClick={onContinuar}>
          Continuar
        </Button>
        {onDescartar && (
          <Button variant="ghost" size="sm" className="min-h-[44px]" onClick={onDescartar}>
            Descartar
          </Button>
        )}
      </div>
    </section>
  );
}
